import {
  Component,
  computed,
  input,
  output,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { SidebarItem } from '../../sidebar.types';
import { Subject } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { SvgIconComponent } from '../../../../shared/components/svg-icon/svg-icon.component';

export interface SidebarApi {
  close: () => void;
  open: () => void;
  toggle: () => void;
}

@Component({
  selector: 'app-sidebar',
  imports: [MatSidenavModule, SvgIconComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements AfterViewInit {
  items = input<SidebarItem[]>([]);
  selectedPrimary = input<string>();
  selectedSecondary = input<string>();
  itemClick = output<string>();
  api = output<SidebarApi>();

  private lastHoveredPrimarySubj = new Subject<string | null>();
  lastHoveredPrimary = toSignal(this.lastHoveredPrimarySubj);
  secondaryItems = computed(() => {
    const items = this.items();
    const hoveredPrimary = this.lastHoveredPrimary();
    const hoveredItem = items.find(item => item.name === hoveredPrimary);
    if (!hoveredItem) {
      this.isSecondaryOpened = false;
      this.secondarySidenav?.close();
      return [];
    }
    this.isSecondaryOpened = (hoveredItem?.children?.length ?? 0) > 0;
    if ((hoveredItem?.children?.length ?? 0) > 0) {
      this.secondarySidenav?.open();
    } else {
      this.secondarySidenav?.close();
    }
    return hoveredItem?.children ?? [];
  });

  @ViewChild('sidenav')
  primarySidenav!: MatSidenav;

  @ViewChild('secondarySidenav')
  secondarySidenav!: MatSidenav;

  isPrimaryOpened = false;
  isSecondaryOpened = false;

  onMouseEnterPrimary(name: string) {
    this.lastHoveredPrimarySubj.next(name);
  }

  onMouseLeavePrimary(item: SidebarItem) {
    if (!item.children?.length) {
      this.lastHoveredPrimarySubj.next(null);
    }
  }

  onClick(event: SidebarItem) {
    if (!event.children || event.children.length === 0) {
      this.itemClick.emit(event.name);
    }
  }

  private close() {
    this.secondarySidenav.close();
    this.primarySidenav.close();
    this.lastHoveredPrimarySubj.next(null);
  }

  private open() {
    this.primarySidenav.open();
  }

  private toggle() {
    this.secondarySidenav.close();
    this.primarySidenav.toggle();
    this.lastHoveredPrimarySubj.next(null);
  }

  ngAfterViewInit() {
    this.api.emit({
      open: () => this.open(),
      close: () => this.close(),
      toggle: () => this.toggle(),
    });
  }
}
